module.exports = __webpack_public_path__ + "static/media/icon_4.3b7da431.svg";